import ColoredTag from '../../components/Tags/ColoredTag';


// Reusable Name Column
export const NameColumn = (itemColors) => ({
  title: 'Name',
  dataIndex: 'symbol',
  key: 'symbol',
  render: (_, record, index) => (
    <ColoredTag
      color={itemColors?.[record.id]}
      name={<div>
        <div> {record?.label}</div>
        <span className={'px-2 border border-blue-200 text-blue-600 rounded-sm'}>
          {index+1}.
        </span>
      </div>}
      width={'100%'}
      shadow={false}
    />
  ),
  width: '20vw',
  minWidth: 150,
});
